// Deep-link handling for the iOS share extension.
// Contract: the app is opened with cooksmith://import?url=<encoded>
// OR cooksmith://import?text=<encoded>.
//
// appUrlOpen (and getLaunchUrl on cold start) can fire before the router
// mounts, so deliverDeepLink buffers the parsed payload until
// DeepLinkHandler registers a handler via setDeepLinkHandler.

let pendingLink = null;
let activeHandler = null;
let lastUrl = null;
let lastUrlAt = 0;

export function parseDeepLink(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  if (!/^cooksmith:\/\/import(\?|$)/i.test(rawUrl)) return null;
  const queryIndex = rawUrl.indexOf('?');
  const params = new URLSearchParams(queryIndex >= 0 ? rawUrl.slice(queryIndex + 1) : '');
  const url = params.get('url');
  const text = params.get('text');
  if (url) return { type: 'url', value: url };
  if (text) return { type: 'text', value: text };
  return null;
}

export function deliverDeepLink(rawUrl) {
  const now = Date.now();
  // appUrlOpen and getLaunchUrl can both report the launch URL — dedupe the double-fire.
  if (rawUrl === lastUrl && now - lastUrlAt < 3000) return false;
  const link = parseDeepLink(rawUrl);
  if (!link) return false;
  lastUrl = rawUrl;
  lastUrlAt = now;
  if (activeHandler) activeHandler(link);
  else pendingLink = link;
  return true;
}

// Returns an unsubscribe function. Flushes any buffered cold-start link immediately.
export function setDeepLinkHandler(handler) {
  activeHandler = handler;
  if (pendingLink) {
    const link = pendingLink;
    pendingLink = null;
    handler(link);
  }
  return () => {
    if (activeHandler === handler) activeHandler = null;
  };
}
